import { doc, getDoc } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';

interface PaymentUrlParams {
  email: string;
  firstName: string;
  lastName: string;
}

export async function getPaymentUrl(planId: string, params: PaymentUrlParams): Promise<string | null> {
  try {
    const planRef = doc(db, collections.plans, planId);
    const planDoc = await getDoc(planRef);

    if (!planDoc.exists()) {
      console.error('Plan not found:', planId);
      return null;
    }

    const planData = planDoc.data();
    const paymentUrl = planData.paymentUrl;

    if (!paymentUrl) {
      console.error('Payment URL not found for plan:', planId);
      return null;
    }

    // Build URL with query parameters
    const url = new URL(paymentUrl);
    url.searchParams.set('checkout[email]', params.email);
    url.searchParams.set('checkout[name]', `${params.firstName} ${params.lastName}`);

    return url.toString();
  } catch (error) {
    console.error('Error getting payment URL:', error);
    return null;
  }
}